import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fba99b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "statement__header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Extrato de Decoins", -1))
const _hoisted_5 = { class: "statement__balance" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Saldo atual: ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "statement__line" }, null, -1))
const _hoisted_8 = { class: "filters" }
const _hoisted_9 = { class: "filter-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Categoria:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Todos", -1))
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "filter-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Tipo de Transação:", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Todos", -1))
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "filter-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Data Inicial:", -1))
const _hoisted_19 = { class: "filter-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Data Final:", -1))
const _hoisted_21 = { class: "statement__table" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "dropdown-wrapper" }
const _hoisted_24 = {
  key: 0,
  class: "dropdown-details"
}
const _hoisted_25 = {
  key: 1,
  class: "dropdown-details"
}
const _hoisted_26 = { class: "product-line" }
const _hoisted_27 = { class: "product-name" }
const _hoisted_28 = { class: "product-decoins" }
const _hoisted_29 = { class: "product-quantity" }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { colspan: "6" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Nenhum extrato encontrado. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateInput = _resolveComponent("DateInput")!
  const _component_OrderTableHeader = _resolveComponent("OrderTableHeader")!
  const _component_TableHeader = _resolveComponent("TableHeader")!
  const _component_Row = _resolveComponent("Row")!
  const _component_Cell = _resolveComponent("Cell")!
  const _component_ContentFallback = _resolveComponent("ContentFallback")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h2", null, [
            _hoisted_6,
            _createElementVNode("span", null, _toDisplayString(_ctx.formatDecoins(_ctx.user.dcoins)), 1)
          ])
        ])
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedType) = $event)),
            class: "select",
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateQuery(_ctx.$router, 'typeCode', _ctx.selectedType)))
          }, [
            _hoisted_11,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentTypes, (content, index) => {
              return (_openBlock(), _createElementBlock("option", {
                key: index,
                value: content.value
              }, _toDisplayString(content.label), 9, _hoisted_12))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.selectedType]
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedTransaction) = $event)),
            class: "select",
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateQuery(_ctx.$router, 'type', _ctx.selectedTransaction)))
          }, [
            _hoisted_15,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactionTypes, (transaction, index) => {
              return (_openBlock(), _createElementBlock("option", {
                key: index,
                value: transaction.value
              }, _toDisplayString(transaction.label), 9, _hoisted_16))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.selectedTransaction]
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createVNode(_component_DateInput, {
            id: "firstDate",
            modelValue: _ctx.firstDate,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.firstDate) = $event)),
            onChange: _cache[5] || (_cache[5] = ($event: any) => (
              _ctx.updateQuery(
                _ctx.$router,
                'firstDate',
                _ctx.dateGrouped($event.target.value)
              )
            ))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createVNode(_component_DateInput, {
            id: "lastDate",
            onChange: _cache[6] || (_cache[6] = ($event: any) => (
              _ctx.updateQuery(_ctx.$router, 'lastDate', _ctx.dateGrouped($event.target.value))
            ))
          })
        ])
      ]),
      _createElementVNode("table", _hoisted_21, [
        _createElementVNode("thead", null, [
          _createVNode(_component_Row, null, {
            default: _withCtx(() => [
              _createVNode(_component_OrderTableHeader, {
                orderBy: "type_code",
                text: "Categoria",
                alignment: "left",
                space: "1.5/12"
              }),
              _createVNode(_component_OrderTableHeader, {
                orderBy: "name_related",
                text: "Nome",
                alignment: "left",
                space: "5/12"
              }),
              _createVNode(_component_OrderTableHeader, {
                orderBy: "type",
                text: "Tipo",
                alignment: "left",
                space: "1/12"
              }),
              _createVNode(_component_TableHeader, {
                text: "Decoins",
                alignment: "center",
                space: "1/12"
              }),
              _createVNode(_component_OrderTableHeader, {
                orderBy: "date",
                text: "Data",
                alignment: "center",
                space: "2/12"
              }),
              _createVNode(_component_TableHeader, {
                text: "",
                alignment: "left",
                space: "0.5/12"
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.statements.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.statements, (statement, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  _createVNode(_component_Row, {
                    class: _normalizeClass({
                  'same-group':
                    index > 0 &&
                    _ctx.statements[index - 1].order?.id === statement.order?.id,
                  'is-clickable': _ctx.isClickable(statement)
                }),
                    onClick: ($event: any) => (_ctx.isClickable(statement) && _ctx.toggleStatement(index))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Cell, {
                        label: "Categoria",
                        alignment: "left"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: _normalizeClass([
                      'statement__category',
                      _ctx.getStatementClassMap(statement)
                    ])
                          }, _toDisplayString(_ctx.formatStatementType(statement.type)), 3)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_Cell, {
                        class: "mobile-move-end",
                        text: _ctx.formatName(statement),
                        label: "Nome",
                        alignment: "left"
                      }, null, 8, ["text"]),
                      _createVNode(_component_Cell, {
                        label: "Tipo",
                        alignment: "left"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("h4", {
                            class: _normalizeClass([
                      'statement__total',
                      _ctx.getStatementClassMap(statement)
                    ])
                          }, _toDisplayString(_ctx.formattedTransaction(
                        statement.transactionType,
                        statement.typeCanceled
                      )), 3)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_Cell, {
                        label: "Decoins",
                        alignment: "center"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("h4", {
                            class: _normalizeClass([
                      'statement__total',
                      _ctx.getStatementClassMap(statement)
                    ])
                          }, _toDisplayString(_ctx.formatDecoins(statement.decoins)), 3)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_Cell, {
                        text: _ctx.formatDateTime(statement.date),
                        label: "Data",
                        alignment: "center"
                      }, null, 8, ["text"]),
                      _createVNode(_component_Cell, {
                        label: "Detalhes",
                        alignment: "left"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.isClickable(statement))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(['arrow', { open: _ctx.openedIndexes === index }]),
                                onClick: _withModifiers(($event: any) => (_ctx.toggleStatement(index)), ["stop","prevent"])
                              }, null, 10, _hoisted_22))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["class", "onClick"]),
                  (_ctx.isClickable(statement) && _ctx.openedIndexes.has(index))
                    ? (_openBlock(), _createBlock(_component_Row, {
                        key: 0,
                        class: "details-row"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Cell, { colspan: "6" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_23, [
                                (statement.type === _ctx.StatementType.COURSE)
                                  ? (_openBlock(), _createElementBlock("ul", _hoisted_24, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statement.contents, (content, cont) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                          key: cont,
                                          class: "detail-item"
                                        }, _toDisplayString(content.title), 1))
                                      }), 128))
                                    ]))
                                  : (statement.type === _ctx.StatementType.PRODUCT)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_25, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statement.order.products, (product, prod) => {
                                          return (_openBlock(), _createElementBlock("li", {
                                            key: prod,
                                            class: "detail-item"
                                          }, [
                                            _createElementVNode("div", _hoisted_26, [
                                              _createElementVNode("p", _hoisted_27, _toDisplayString(product.name), 1),
                                              _createElementVNode("p", _hoisted_28, "-" + _toDisplayString(_ctx.formatDecoins(product.decoins)), 1),
                                              _createElementVNode("p", _hoisted_29, "Qtde: " + _toDisplayString(product.quantity), 1)
                                            ])
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            : (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                _createElementVNode("td", _hoisted_31, [
                  _createVNode(_component_ContentFallback, null, {
                    default: _withCtx(() => [
                      _hoisted_32
                    ]),
                    _: 1
                  })
                ])
              ]))
        ])
      ]),
      (_ctx.statements.length)
        ? (_openBlock(), _createBlock(_component_Pagination, {
            key: 0,
            class: "pagination",
            "qt-pages": _ctx.numberOfPages,
            currentPage: Number(_ctx.$route.query.page) || 1,
            onChangePage: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateQuery(_ctx.$router, 'page', $event)))
          }, null, 8, ["qt-pages", "currentPage"]))
        : _createCommentVNode("", true)
    ])
  ]))
}